let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lhylB")).then(() => parcelRequire('f1pBd'));